import {createUseStyles} from 'react-jss';

export default createUseStyles({
  autocompleteField: {
    position: 'relative',
    flexGrow: 1,
  
    // Hide in built browser clear input button on search input types
    '& input[type="search"]::-webkit-search-cancel-button': {
      display: 'none',
    },
    '& input[type="search"]::-ms-clear': {
      display: 'none',
      width: 0,
      height: 0,
    },
  },
  listBox: {
    position: 'absolute',
    zIndex: 11,
    width: '100%',
    margin: [1, 0, 0], // adding to take in account for focus border of input
    padding: 0,
    listStyle: 'none',
    background: '#fff',
    overflowY: 'scroll',
    maxHeight: '36vh',
    boxShadow: '0 2px 4px 0 rgb(51 51 51 / 20%), 0 0 4px 1px rgb(51 51 51 / 10%)',
    borderTop: [8, 'solid', '#f2f2f2'],
    borderBottom: [8, 'solid', '#f2f2f2'],
  },
  fallbackWrapper: {
    padding: 12,
  },
  searchIcon: {
    display: 'inline-flex',
    position: 'absolute',
    right: 0,
    height: '100%',
    zIndex: 1,
    borderRadius: [0, 4, 4, 0],
    background: props => (props.value !== '' && props.predictions.length > 0) && props.theme.core.brand,
    color: props => (props.value !== '' && props.predictions.length > 0
      ? props.theme.core.background : props.theme.core.foreground),
    
    '&:hover, &:focus': {
      color: props => props.theme.core.foreground,
      background: '#f2f2f2',
    },
  },
  collectionWrapper: {
    width: '100%',
    display: 'flex',
  },
  boxSearchButton: {
    marginLeft: 10,
    width: 100,
    height: 40,
    fontWeight: 'normal',
    alignItems: 'baseline',
  },
  newCollectionWrapper: {
    width: '100%',
    display: 'flex',
  },
  newBoxSearchButton: {
    marginLeft: 10,
    width: props => (props.isMobile ? 135 : 275),
    height: 40,
    fontWeight: 'normal',
    alignItems: 'baseline',
  },
});
